import { useVoiceRegion } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Button, Card, Container, Grid, Header } from "semantic-ui-react";
import OutboundRouteCreateForm from "./OutboundRouteCreateForm";
import OutboundRouteEditForm from "./OutboundRouteEditForm";
import OutboundRouteTable from "./OutboundRouteTable";

const OutboundRouteView = () => {
  const { createVoiceRegionRoute, outboundRoute, createOutboundRoute } =
    useVoiceRegion();

  if (createOutboundRoute) {
    return (
      <Container>
        <h2>Create Route</h2>
        <Card fluid>
          <Card.Content>
            <OutboundRouteCreateForm />
          </Card.Content>
        </Card>
      </Container>
    );
  }

  if (outboundRoute) {
    return (
      <Container>
        <h2>Edit Route</h2>
        <Card fluid>
          <Card.Content>
            <OutboundRouteEditForm />
          </Card.Content>
        </Card>
      </Container>
    );
  }

  return (
    <Fragment>
      <Header as='h3'>Outbound Proxies</Header>
      <Card fluid>
        <Card.Content>
          <Grid stackable padded>
            <Grid.Column width={14}></Grid.Column>
            <Grid.Column width={2} style={{ textAlign: "right" }}>
              <Button primary onClick={() => createVoiceRegionRoute()}>
                Create
              </Button>
            </Grid.Column>
          </Grid>
        </Card.Content>
        <Card.Content>
          <OutboundRouteTable />
        </Card.Content>
      </Card>
    </Fragment>
  );
};

export default OutboundRouteView;
